import { render, staticRenderFns } from "./SaDashboard.vue?vue&type=template&id=636df409&scoped=true&"
import script from "./SaDashboard.vue?vue&type=script&lang=js&"
export * from "./SaDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636df409",
  null
  
)

export default component.exports